import React, { useState } from "react";
import CustomSelect from "../../../../components/common/CustomSelect";
import { Button } from "../../../../components/common/Button";
import { ContentWrapper, Error } from "../styles";

export const DESTINATION_OPTIONS = [
  { label: "China", value: "China" },
  { label: "Nigeria", value: "Nigeria" },
];

type Props = {
  onContinue: (destinationCountry: string) => void;
};

const DestinationCountry = ({ onContinue }: Props) => {
  const [destinationCountry, setDestinationCountry] = useState<string | null>(
    null,
  );
  const [error, setError] = useState("");

  const handleContinue = () => {
    if (!destinationCountry) {
      setError("Beneficiary country is required");
      return;
    }

    setError("");
    onContinue(destinationCountry);
  };

  return (
    <ContentWrapper>
      <CustomSelect
        $width="100%"
        placeholder="Beneficiary country"
        options={DESTINATION_OPTIONS}
        value={destinationCountry}
        onChange={(value: string) => {
          setDestinationCountry(value);
          setError("");
        }}
        lightBorder
      />
      {error && <Error>{error}</Error>}
      <Button
        label="Continue"
        height="48px"
        onClick={handleContinue}
        disabled={!destinationCountry}
      />
    </ContentWrapper>
  );
};

export default DestinationCountry;
